import { inject } from '@angular/core';
import { withDevtools } from '@angular-architects/ngrx-toolkit';

import { BehaviorSubject, filter, pipe, switchMap, tap } from 'rxjs';
import { patchState, signalStore, withMethods, withProps, withState } from '@ngrx/signals';
import { removeAllEntities, setAllEntities, withEntities } from '@ngrx/signals/entities';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { tapResponse } from '@ngrx/operators';

import { ApplicationSubmodule } from './application-submodules.types';
import { ApplicationSubmodulesApiService } from './application-submodules-api.service';

interface ApplicationSubmodulesState {
  error: unknown | null;
  loadedModule: string | null;
}

const initialState = Object.freeze<ApplicationSubmodulesState>({
  error: null,
  loadedModule: null,
});

export const ApplicationSubmodulesStore = signalStore(
  withDevtools('Application Submodules'),

  withState(initialState),

  withEntities<ApplicationSubmodule>(),

  withProps(() => ({
    _apiService: inject(ApplicationSubmodulesApiService),
  })),

  withProps(() => ({
    isLoading$: new BehaviorSubject(true),
  })),

  withMethods((store) => {
    return {
      load: rxMethod<{ module: string | null; personId: string | null; device: string | null }>(
        pipe(
          filter(
            (payload): payload is { module: string; personId: string; device: string | null } =>
              payload.module !== null && payload.personId !== null
          ),
          tap(() => store.isLoading$.next(true)),
          switchMap(({ module, personId, device }) =>
            store._apiService.get(module, personId, { device }).pipe(
              tapResponse({
                next: (modules) => patchState(store, setAllEntities(modules), { loadedModule: module }),
                error: (error) => patchState(store, { error, loadedModule: module }, removeAllEntities()),
                finalize: () => store.isLoading$.next(false),
              })
            )
          )
        )
      ),
    };
  })
);
